import { MainLayout } from "layouts";
import { useAuthState } from "shared/hooks";
import styles from "./styles.module.scss";

const WithoutPermissionPageContent: React.FC = () => {
	return (
		<div className={styles.container}>
			<h1>Without Permission</h1>
			<p>You do not have the necessary permissions to access this page.</p>
		</div>
	);
};

export const WithoutPermissionPage: React.FC = () => {
	const userStatus = useAuthState();

	return userStatus === "signed" ? (
		<MainLayout>
			<WithoutPermissionPageContent />
		</MainLayout>
	) : (
		<WithoutPermissionPageContent />
	);
};
